import React, { useState,useEffect } from 'react'
import './NewCollections.css'
// import new_collection from '../Assets/new_collections'
import Item from '../Item/Item'
const NewCollections = () => {
  
  const[new_collection,setNew_collection]=useState([]);
  useEffect(()=>{
    fetch('https://sarathi-0cyh.onrender.com/newcollections')
      .then((response) => {
        if (!response.ok) throw new Error(response.statusText);
        return response.json();
      })
      .then((data) => setNew_collection(data))
      .catch((err) => {
        console.error('Failed to fetch new collections:', err);
        setNew_collection([]);
      });
  },[])

  return (
    <div className='new-collections'>
      <h1>NEW COLLECTIONS</h1>
      <hr/>
      <div className="collections">
        {new_collection.map((item,i)=>{
       return <Item key={i} id={item.id} name={item.name} image={item.image} new_price={item.new_price} old_price={item.old_price}/>
        })}
      </div>
    </div>
  )
}

export default NewCollections
